export default "__VITE_ASSET__BolQFb4y__"